import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { SectionHeader, StatTile, Pill, EmptyState } from "@/components/Brand";
import { Map, ClipboardList, ChevronRight, Building2 } from "lucide-react";

export default function SurveyorWards() {
  const [wards, setWards] = useState([]);
  const [coverage, setCoverage] = useState(null);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    Promise.all([
      api.get("/surveyor/wards"),
      api.get("/surveyor/coverage"),
    ])
      .then(([w, c]) => {
        setWards(w.data);
        setCoverage(c.data);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <SectionHeader eyebrow="Field Surveyor" title="Your assigned wards" />

      <div className="grid grid-cols-2 gap-3 mb-6">
        <StatTile label="My Submissions" value={coverage?.total_submissions ?? 0} icon={ClipboardList} />
        <StatTile label="Wards Assigned" value={wards.length} icon={Map} />
      </div>

      {!loading && wards.length === 0 && (
        <EmptyState
          title="No wards assigned yet"
          hint="Contact your administrator to get wards assigned to your account."
        />
      )}

      <div className="space-y-3">
        {wards.map((w) => (
          <button
            key={w.id}
            onClick={() => nav(`/surveyor/wards/${w.id}`)}
            data-testid={`surveyor-ward-${w.name.toLowerCase()}`}
            className="w-full wi-card p-4 flex items-center justify-between hover:border-blue-300 wi-lift text-left"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-md bg-blue-50 text-blue-700 flex items-center justify-center">
                <Building2 size={18} />
              </div>
              <div>
                <div className="font-semibold text-slate-900">{w.name}</div>
                <div className="text-xs text-slate-500">{w.district} · {w.booth_count} booths</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <Pill tone="blue">My: {w.my_count ?? 0}</Pill>
              <ChevronRight size={16} className="text-slate-400" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
